import { ChangeDetectionStrategy, Component, inject, type OnInit, signal, type WritableSignal } from '@angular/core';

import { type ToastItemData, ToastService } from ':core/services/toast.service';

import { slideInAnimation } from './animations/slide-in.animation';
import { slideOutAnimation } from './animations/slide-out.animation';
import { triggerChildAnimation } from './animations/trigger-child.animation';
import { verticalCollapseAnimation } from './animations/vertical-collapse.animation';
import { ToastItemComponent } from './toast-item/toast-item.component';

@Component({
    selector: 'app-toast',
    templateUrl: 'toast.component.html',
    styleUrls: ['toast.component.scss'],
    animations: [slideInAnimation, slideOutAnimation, verticalCollapseAnimation, triggerChildAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ToastItemComponent],
})
export class ToastComponent implements OnInit {
    private readonly _toastService = inject(ToastService);

    protected readonly items: WritableSignal<ToastItemData[]> = signal([]);

    ngOnInit(): void {
        this._toastService.items$.subscribe((item) => {
            if (item) {
                this.items.update((items) => [...items, item]);
            }
        });
    }

    dismissItem(index: number): void {
        this.items.update((items) => {
            items.splice(index, 1);
            return [...items];
        });
    }
}
